const getCurrentDate = (time, timezone = "05:00") =>
  new Date(Date.now() + 5 * 3600 * 1000).toISOString().split('T')[0] + "T" + time + ":00+" + timezone;

const getNextDate = (time, timezone = "05:00") =>
  new Date(Date.now() + (5 + 24) * 3600 * 1000).toISOString().split('T')[0] + "T" + time + ":00+" + timezone;

export function getSpecialClientIntervals() {
  return [
    { intervalTitle: "12:00-12:10", startTime: getCurrentDate("12:00"), endTime: getCurrentDate("12:10") },
    { intervalTitle: "18:00-18:10", startTime: getCurrentDate("18:00"), endTime: getCurrentDate("18:10") },
    { intervalTitle: "21:00-21:10", startTime: getCurrentDate("21:00"), endTime: getCurrentDate("21:10") },
  ];
}

export function getSpecialClientDeliveryIntervals() {
  return [
    { intervalTitle: "12:00-12:10", startTime: getNextDate("12:00"), endTime: getNextDate("12:10") },
    { intervalTitle: "18:00-18:10", startTime: getNextDate("18:00"), endTime: getNextDate("18:10") },
    { intervalTitle: "21:00-21:10", startTime: getNextDate("21:00"), endTime: getNextDate("21:10") },
  ];
}

export const FALLBACK_INTERVAL = [
  { intervalTitle: "08:00-20:00", startTime: "2024-04-19T08:00:00+05:00", endTime: "2024-04-19T20:00:00+05:00" },
];
